module.exports = __webpack_public_path__ + "static/media/dynamo.d700a644.png";